import { Column, ColumnWithFunctionAccessor } from 'react-table'

import { monthDayYear } from '../../../../../utils/dateTools'
import { formatAsCurrencyOrZero } from '../../../../../utils/priceTools'
import { OrderCell } from './OrderCell'
import { TrackingCell } from './TrackingCell'
import { TableDataCustomerOrder, TableDataOrder, TableDataRewardsOrder } from './types'
import { withUrlFragment } from './withUrlFragment'

export const dateColumn = <TData extends TableDataOrder>(
  urlFragment: string,
): ColumnWithFunctionAccessor<TData> => ({
  Header: 'Date',
  id: 'date',
  className: 'noWrapColumn',
  accessor: (order) => monthDayYear(order.date),
  disableSortBy: false,
  sortType: (a, b) => {
    if (a.original.date > b.original.date) return 1
    return -1
  },
  Cell: withUrlFragment(OrderCell, urlFragment),
})

export const orderNumberColumn = <TData extends TableDataOrder>(
  urlFragment: string,
): ColumnWithFunctionAccessor<TData> => ({
  Header: 'Order No.',
  id: 'orderNumber',
  className: 'noWrapColumn',
  accessor: (order) => `#${order.orderNumber}`,
  disableSortBy: true,
  Cell: withUrlFragment(OrderCell, urlFragment),
})

export const shipToAddresseeColumn = (
  urlFragment: string,
): ColumnWithFunctionAccessor<TableDataCustomerOrder> => ({
  Header: 'Ship to Addressee',
  id: 'addressee',
  className: 'desktopOnly',
  accessor: (order) => order.shippingAddress?.addressee || 'N/A',
  disableSortBy: true,
  Cell: withUrlFragment(OrderCell, urlFragment),
})

export const customerNameColumn = (
  urlFragment: string,
): ColumnWithFunctionAccessor<TableDataRewardsOrder> => ({
  Header: 'Name',
  id: 'name',
  className: 'desktopOnly',
  accessor: (order) => order.orderCustomerName,
  disableSortBy: true,
  Cell: withUrlFragment(OrderCell, urlFragment),
})

export const totalColumn = <TData extends TableDataOrder>(
  urlFragment: string,
): ColumnWithFunctionAccessor<TData> => ({
  Header: 'Total',
  id: 'total',
  className: 'noWrapColumn',
  accessor: (order) => formatAsCurrencyOrZero({ amount: order.total }),
  disableSortBy: true,
  Cell: withUrlFragment(OrderCell, urlFragment),
})

export const statusColumn = <TData extends TableDataOrder>(urlFragment: string): Column<TData> => ({
  Header: 'Status',
  className: 'statusColumn',
  accessor: 'status',
  disableSortBy: true,
  Cell: withUrlFragment(OrderCell, urlFragment),
})

export const trackingColumn = <TData extends TableDataOrder>(
  urlFragment: string,
): Column<TData> => ({
  Header: '',
  id: 'tracking',
  className: 'desktopOnly textRight',
  accessor: 'orderId',
  disableSortBy: true,
  Cell: withUrlFragment(TrackingCell, urlFragment),
})
